import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { IpnDetailsTabContent } from '@/areas/components/IpnDetailsPage/components/IpnDetailsTabController';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/components/ipn/_details/cpns')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'home' } satisfies PageStaticData,
    validateSearch: stringSearch({ ipnId: 'required' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const ipnId = Route.useSearch({ select: (search) => search.ipnId });
    return <IpnDetailsTabContent tab={'cpns'} ipnId={ipnId} />;
}
